export function isInvalidDocumentItemNumber(value: unknown, allowZero = false): boolean {
  return (
    typeof value !== 'number' || !Number.isFinite(value) || (allowZero ? value < 0 : value <= 0)
  );
}
